import React from "react"
import { Box, Button, Container, Heading, ResponsiveValue, Stack } from "@chakra-ui/react"

import { SectionProps, withSection } from "@app/hoc/Section"
import { useRoutes } from "@hooks/useRoutes"
import Link from "@components/Link"
import VideoCarousel from "./VideoCarousel"

export type FeaturedVideosProps = GatsbyTypes.SanitySectionFeaturedVideos & SectionProps

const FeaturedVideos = ({
  title,
  link,
  videos,
  theme,
  alignment,
  carouselSettings,
  innerRef,
  handleTrackingClick,
}: FeaturedVideosProps) => {
  const { urlResolver } = useRoutes()
  const resolvedLink = urlResolver(link)
  const align = (alignment?.toString() || "center") as ResponsiveValue<any>

  return (
    <Box py={5} bg={theme === "Dark" ? "brand.beige.dark" : "white"} ref={innerRef} as="section">
      <Stack textAlign={align} alignItems={align} spacing={2.5}>
        <Heading as="h2" size="h2">
          {title}
        </Heading>
        <Container pr={0}>
          {videos && <VideoCarousel videos={videos} carouselSettings={carouselSettings} handleTrackingClick={handleTrackingClick} />}
        </Container>
        {link && (
          <Button variant="blue" as={Link} to={resolvedLink.url}>
            {resolvedLink.title}
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default React.memo(withSection(FeaturedVideos))
